// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2uwng","item":"PaymentsMobile_item__3h-SY","label":"PaymentsMobile_label__2naXJ","amount":"PaymentsMobile_amount__kaiFG"};